import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  MinioIngressDetails,
  MinioIngressList,
} from "../../../api/ingressRpcApi";
import { getIngressAsync } from "./ingressDetailsThunks";
import { LoadingStatus } from "../../../common/types";

export interface IListIngress {
  getIngressLoading: LoadingStatus;
  details: MinioIngressDetails | null;
  selectedSite: string;
  namespace: string;
  ingressList: MinioIngressList;
  validationErrors: { [key: string]: string };
}

const initialState: IListIngress = {
  getIngressLoading: "neverLoaded",
  details: null,
  selectedSite: "",
  namespace: "",
  ingressList: {},
  validationErrors: {},
};

export const listIngressReducer = createSlice({
  name: "listIngress",
  initialState,
  reducers: {
    setIngressSelectedSite: (state, action: PayloadAction<string>) => {
      state.selectedSite = action.payload;
    },
    setIngressNamespace: (state, action: PayloadAction<string>) => {
      state.namespace = action.payload;
    },
    setIngressList: (state, action: PayloadAction<MinioIngressList>) => {
      state.ingressList = action.payload;
    },
    resetIngressDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIngressAsync.pending, (state) => {
        state.getIngressLoading = "loading";
      })
      .addCase(getIngressAsync.rejected, (state) => {
        state.getIngressLoading = "failed";
      })
      .addCase(getIngressAsync.fulfilled, (state, action) => {
        state.getIngressLoading = "idle";
        state.details = action.payload;
      });
  },
});

export const {
  resetIngressDetails,
  setIngressSelectedSite,
  setIngressNamespace,
  setIngressList,
} = listIngressReducer.actions;

export default listIngressReducer.reducer;
